module.exports = __webpack_public_path__ + "27f71a43120da55ad9db898236fcf783.jpg";